export default {
  namespaced: true,
  state: {
    selectionTables: [],
    availableForReservation : [],
    tablesOfCurrentReservation : [],
    tablesOfNearestReservation : [],
    tablesWhereHasReservations : [],
    modeTransfer : false,

  },
  getters: {
    getSelectionTables: (state) => {
      return state.selectionTables;
    },
    getAvailableForReservation: (state) => {
      return state.availableForReservation;
    },
    getTablesOfCurrentReservation: (state) => {
      return state.tablesOfCurrentReservation;
    },
    getTablesOfNearestReservation: (state) => {
      return state.tablesOfNearestReservation;
    },
    getTablesWhereHasReservations: (state) => {
      return state.tablesWhereHasReservations;
    },
    isTransfer: (state) => {
      return state.modeTransfer;
    },
  },
  mutations: {
    setTablesWhereHasReservations: (state, payload) => {
      state.tablesWhereHasReservations = payload;
    },
    setSelectionTables: (state, payload) => {
      state.selectionTables = payload;
    },
    setAvailableForReservation: (state, payload) => {
      state.availableForReservation = payload;
    },
    setTablesOfCurrentReservation: (state, payload) => {
      state.tablesOfCurrentReservation = payload;
    },
    setTablesOfNearestReservation: (state, payload) => {
      state.tablesOfNearestReservation = payload;
    },
    setModeTransfer: (state, payload) => {
      state.modeTransfer = payload;
    },
  }
}
